export default __webpack_public_path__ + "static/media/services02.6bc10d7e.jpg";